(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["two-collection-showcase"] && !Shopify.designMode) return;
  try {
    
  class TwoCollectionShowcase extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.two-collection-showcase__viewport');
      this.items = this.querySelectorAll('.two-collection-showcase__item');
      this.dots = this.querySelectorAll('[data-tcs-dot]');
      this.enableMobileScroll = this.dataset.enableMobileScroll === 'true';
      this.autoScroll = this.dataset.autoScroll === 'true';
      this.autoInterval = Number(this.dataset.autoInterval) || 3500;
      this.scrollDuration = Number(this.dataset.scrollDuration) || 500;
      this.mediaQuery = window.matchMedia('(max-width: 749px)');
      this.activeIndex = 0;
      this.scrollFrame = null;
      this.interval = null;

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.pauseAutoScroll();
          this.scrollToSlide(Number(dot.dataset.tcsDot));
        });
      });

      if (this.viewport) {
        this.viewport.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
        this.viewport.addEventListener('pointerenter', this.pauseAutoScroll.bind(this));
        this.viewport.addEventListener('pointerleave', this.startAutoScroll.bind(this));
        this.viewport.addEventListener('touchstart', this.pauseAutoScroll.bind(this), { passive: true });
        this.viewport.addEventListener('touchend', this.startAutoScroll.bind(this), { passive: true });
      }

      this.startAutoScroll();
    }

    disconnectedCallback() {
      this.pauseAutoScroll();

      if (this.scrollFrame) {
        window.cancelAnimationFrame(this.scrollFrame);
      }
    }

    onScroll() {
      window.requestAnimationFrame(() => {
        const width = this.viewport.clientWidth;
        const index = width > 0 ? Math.round(this.viewport.scrollLeft / width) : 0;
        this.activeIndex = Math.max(0, Math.min(index, this.items.length - 1));
        this.setActiveDot(this.activeIndex);
      });
    }

    canAutoScroll() {
      return this.viewport && this.enableMobileScroll && this.autoScroll && this.items.length > 1 && this.mediaQuery.matches;
    }

    startAutoScroll() {
      this.pauseAutoScroll();

      if (!this.canAutoScroll()) {
        return;
      }

      this.interval = window.setInterval(() => {
        const nextIndex = (this.activeIndex + 1) % this.items.length;
        this.scrollToSlide(nextIndex);
      }, this.autoInterval);
    }

    pauseAutoScroll() {
      if (this.interval) {
        window.clearInterval(this.interval);
        this.interval = null;
      }
    }

    scrollToSlide(index) {
      if (!this.viewport) {
        return;
      }

      const target = this.viewport.clientWidth * index;
      this.animateScroll(target);
      this.activeIndex = index;
      this.setActiveDot(index);
    }

    animateScroll(target) {
      const start = this.viewport.scrollLeft;
      const distance = target - start;
      const duration = Math.max(0, this.scrollDuration);
      const startTime = performance.now();

      if (this.scrollFrame) {
        window.cancelAnimationFrame(this.scrollFrame);
      }

      if (duration === 0) {
        this.viewport.scrollLeft = target;
        return;
      }

      const tick = (now) => {
        const progress = Math.min((now - startTime) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        this.viewport.scrollLeft = start + distance * eased;

        if (progress < 1) {
          this.scrollFrame = window.requestAnimationFrame(tick);
        }
      };

      this.scrollFrame = window.requestAnimationFrame(tick);
    }

    setActiveDot(index) {
      this.dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === index);
      });
    }
  }

  if (!customElements.get('two-collection-showcase')) {
    customElements.define('two-collection-showcase', TwoCollectionShowcase);
  }

  } catch(e) { console.error(e); }
})();
})();
